import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { GerinusBD } from 'src/app/app-core/lib/gerinus-bd.component';

import { GlobalService } from 'src/app/app-core/lib/global.service';
import { OrganizationService } from 'src/app/app-core/services/organization.service';
import { SubjectService } from 'src/app/app-core/services/subject.service';
import { RequestService } from 'src/app/app-core/services/request.service';
import { EvaluationTermService } from 'src/app/app-core/services/evaluation-term.service';
import { PersonService } from 'src/app/app-core/services/person.service';
import { UserService } from 'src/app/app-core/services/user.service';

import swal from 'sweetalert2';
import 'bootstrap/dist/js/bootstrap.bundle';
import { IOrganization } from 'src/app/interfaces/organization';
import { ISubject } from 'src/app/interfaces/subject';
import { SubjectAttachmentService } from 'src/app/app-core/services/subject-attachment.service';
import { typeFormRequestEnum } from 'src/app/Enums/TypeFormRequestEnum';
import { SignStatusEnum } from 'src/app/Enums/SignStatusEnum';
import { DocumentFormService } from 'src/app/app-core/services/document-form.service';
import { IAttachmentSubject } from 'src/app/interfaces/attachmentSubjects';
import { DocumentService } from 'src/app/app-core/services/document.service';
import { IDocumentFormRequest } from 'src/app/interfaces/documentRequestForm';
import { TagsService } from 'src/app/app-core/services/tags.service';
import { AutoridadeEnum } from 'src/app/Enums/autoridadeTypeEnum';
import { UserDataRequestComponent } from './components/user-data-request/user-data-request.component';
import { FormRequestDefaultComponent } from 'src/app/app-core/modules/forms/form-request-default/form-request-default.component';
import { AttachmentsRequestComponent } from './components/attachments-request/attachments-request.component';
import { UploadService } from 'src/app/app-core/services/upload.service';
import { IPdfData } from 'src/app/interfaces/signature-gov.interfaces';
import { environment } from 'src/environments/environment';
import { ApplicantRequestService } from 'src/app/app-core/services/applicant-request.service';
import { Request } from 'src/app/interfaces/request';
import { ProcessService } from 'src/app/app-core/services/process.service';
import { DepartmentService } from 'src/app/app-core/services/department.service';
import { IDepartment } from 'src/app/interfaces/department';
import { IListScopeDepartmentResponse } from 'src/app/interfaces/listScope/listScopeDepartmentResponse';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormRequestAlvaraComponent } from 'src/app/app-core/modules/forms/form-request-alvara/form-request-alvara.component';
import { FormRequestInscricaoMunicipalComponent } from 'src/app/app-core/modules/forms/form-request-inscricao-municipal/form-request-inscricao-municipal.component';
import { FormRequestSemurbComponent } from 'src/app/app-core/modules/forms/form-request-semurb/form-request-semurb.component';
import { FormRequestDynamicComponent } from 'src/app/app-core/modules/forms/form-request-dynamic/form-request-dynamic.component';
import * as moment from 'moment';
import { UpdateRegistrationComponent } from './components/update-registration-request/update-registration-request.component';
import { DigitalFormService } from 'src/app/app-core/services/digital-form.service';
import {
    IDigitalFormPrepareSignResponse,
    IDigitalFormRepresentado,
    IDigitalFormSignaturePosition,
    IDigitalFormSubmission,
} from 'src/app/interfaces/digital-form';
import { DigitalFormFieldTypeEnum } from 'src/app/Enums/DigitalFormEnum';
import { CryptoService } from 'src/app/app-core/services/crypto.service';
import { orgIcon } from 'src/app/app-core/lib/request-status';

/**
 * Etapas da solicitação, na ordem em que aparecem. INICIO é a escolha do serviço e
 * REQUERENTE o "para quem"; as duas são atendidas pelo mesmo UserDataRequestComponent.
 */
export enum StepperPositionEnum {
    ATUALIZACAO_CADASTRAL = 0,
    INICIO = 1,
    REQUERENTE = 2,
    DETALHAMENTO = 3,
    DOCUMENTOS = 4,
    RESUMO = 5,
    DOCUMENTO_SOLICITACAO = 6
}

interface IRequestStep {
    id: StepperPositionEnum;
    title: string;
    hint: string;
}

/** Chaves do rascunho da solicitação no localStorage (o logout limpa as mesmas, no LoginService). */
const REQUEST_DRAFT_KEYS = [
    'user-data-solicitacao',
    'user-data-requerente',
    'user-data-procuracao',
    'user-data-check-another-applicant',
    'attachments-request-documentos',
    'new-request-descricao',
    'update-registration-form',
    'form-request-inscricao-municipal',
    'form-request-alvara',
    'form-request-semurb',
    'form-request-iptu',
    'form-request-itbi',
    'form-request-sead',
    'form-request-dynamic',
];

/** O que a tela de confirmação mostra depois do envio. */
interface ISubmittedRequest {
    id: number;
    numero: string | null;
    entity: any;
}

@Component({
    selector: 'app-new-request',
    templateUrl: './new-request.component.html',
    styleUrls: ['./new-request.component.scss'],
    providers: [
        RequestService,
        OrganizationService,
        SubjectService,
        EvaluationTermService,
        PersonService,
        UserService,
        SubjectAttachmentService,
        DocumentFormService,
        DocumentService,
        TagsService,
        ApplicantRequestService,
        ProcessService,
        DigitalFormService,
        DepartmentService
    ],
})
export class NewRequestComponent extends GerinusBD implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('userData') userData: UserDataRequestComponent;
    @ViewChild('attachmentsRequest') attachmentsRequest: AttachmentsRequestComponent;
    @ViewChild('formDefault') formDefault: FormRequestDefaultComponent;
    @ViewChild('formDynamic') formDynamic: FormRequestDynamicComponent;
    @ViewChild('updateRegistrationUser') updateRegistrationUser: UpdateRegistrationComponent;
    @ViewChild(FormRequestAlvaraComponent) formAlvara: FormRequestAlvaraComponent;
    @ViewChild('formInscricaoMunicipal') formInscricaoMunicipal: FormRequestInscricaoMunicipalComponent;
    @ViewChild('formSemurb') formSemurb: FormRequestSemurbComponent;

    termAccepted: boolean;
    hasForm = false;

    public readonly stepIds = StepperPositionEnum;
    public organizations: IOrganization[];
    public subjects: ISubject[] = [];
    public departments: IDepartment[] = [];
    public request: Request;
    public swal = swal;
    public userName;
    public selectedStep = 1;
    public nomeOrgao: string;
    public assuntoDescricao: string;
    public assuntoTipo: string;
    public currentDate: Date = new Date();
    public requiredFieldsFirstStep;
    public requiredFieldsSecondStep;
    public requiredFieldsFirstStepFilled: boolean;
    public requiredFieldsSecondStepFilled: boolean;
    public requiredFieldsThirdStepFilled: boolean;
    public mimeTypes: string[] = ['application/pdf'];

    // FORMULÁRIO DIGITAL DINÂMICO
    /** PDF gerado para assinatura, com a versão do formulário que ele representa. */
    private dynamicPreview: IDigitalFormPrepareSignResponse | null = null;
    /** Validade apenas da etapa que o cidadão está preenchendo. */
    private dynamicPageValid = false;
    /** Respostas do PDF atual, para não regerá-lo a cada passo. */
    private dynamicPdfKey: string | null = null;
    private dynamicSignedFile: { anexo: string; nomeAnexo: string } | null = null;

    public specificSubjectsIPTU: string[];
    public validateForm: boolean;
    public subjectForm: string;
    public attachments: IAttachmentSubject[];
    public modalName: string = 'solicitacao-sucesso';
    public havePdfBuffer = false;
    public saveDocumentData: any;
    public renderModalAccountLevel = false;
    public requestCode: number;
    public entity: any = { formulariosDTI: {} }

    public process = {
        department: '',
        PRC_CodigoSolicitacao: 0,
        SOL_Autorizante: 0,
        PRCH_Historico: '',
        PRC_DataRecebimento: new Date(this.global.currentDate.setHours(this.global.currentDate.getHours() - 3)),
    };

    /** O cadastro passou de três meses sem atualização: a primeira etapa é confirmá-lo. */
    public needsRegistrationUpdate = false;
    /** Etapa mais adiante já visitada: até ela, a trilha lateral permite voltar e avançar. */
    public maxReachedStep = StepperPositionEnum.INICIO;
    /** Preenchido no envio: a tela de confirmação toma o lugar do formulário. */
    public submitted: ISubmittedRequest | null = null;
    public protocolCopied = false;

    public documentForm: IPdfData;
    public iSrc: string;
    public tagSubjectName: string;
    public customNewRequest: string;
    public tagCodigo: number;
    public mimeTypeSupplementary: string[] = [
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];
    public updateRegistrationData: any;

    private termScreeningAccepted: boolean = false;
    private requestSaved = false;
    public pdfUploadedFileCloudFlare: string;
    public pdfFileCloudFlareUrl: string;
    private destroy$ = new Subject();


    constructor(
        public requestService: RequestService,
        public global: GlobalService,
        public uploadService: UploadService,
        public organizationService: OrganizationService,
        public subjectService: SubjectService,
        public personService: PersonService,
        public userService: UserService,
        public tagsService: TagsService,
        public documentFormService: DocumentFormService,
        public documentService: DocumentService,
        public evaluationTermService: EvaluationTermService,
        public applicantRequestService: ApplicantRequestService,
        private cd: ChangeDetectorRef,
        public proccessService: ProcessService,
        public departmentService: DepartmentService,
        public digitalFormService: DigitalFormService,
        private cryptoService: CryptoService
    ) {
        super(global, requestService);
        this.afterCreate();
        this.showEmptyData = false;
        this.showHeader = false;
        this.showPaginate = false;
        this.specificSubjectsIPTU = this.subjectService.specificSubjectsIPTU;
    }

    ngOnDestroy(): void {
        if (this.requestSaved === false) {
            this.deleteRequestRecords();
        }

        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.add();
        this.customNewRequest = this.userService.isCidadao()
        ? 'mt-4 mt-md-5 mt-lg-4'
        : 'mt-4 mt-md-8 mt-lg-8';
        this.verifyRegistrationUser()
    }

    ngAfterViewInit(): void {
        this.entity = this.defaults()

        const title = document.querySelector('title');
        title.text = 'Nova Solicitação';
        this.cd.detectChanges();
    }

    public getNomeUsuario(personId: number) {
        this.personService.getEntity(personId).subscribe({
            next: (response: any) => {
                this.userName = response.entity.PE_Nome;
            },
        });
    }

    public deleteRequestRecords() {
        this.uploadService.deleteFile(this.pdfUploadedFileCloudFlare, 'documento', 'SIGN').subscribe({
            next: (response: any) => {
            }
        })
    }

    public defaults() {
        return {
            applicantRequest: this.userData?.form?.get('applicantRequest')?.value,
            solicitacao: {
                SOL_CodigoOrgao: this.userData?.solicitacaoFormGroup.get('SOL_CodigoOrgao').value,
                SOL_CodigoAssunto: this.userData?.solicitacaoFormGroup.get('SOL_CodigoAssunto').value,
                SOL_CodigoSolicitante: this.userData?.solicitacaoFormGroup.get('SOL_CodigoSolicitante').value,
                SOL_Status: 0,
                SOL_CodigoDocumento: null,
                SOL_Descricao: this.formDefault?.form.get('formVariants').get('SOL_Descricao')?.value,
                SOLH_Historico: 'A solicitação está em análise',
            },
            requerente: {
                SOLR_TipoInscricao: '2',
            },
            formularios: {},
            documentos: {
                procuracao: this.userData?.form.get("procuracao")?.value || [],
                requerimento: this.attachmentsRequest?.entity.documentos.requerimento || [],
                complementar: this.attachmentsRequest?.entity.documentos.complementar || [],
            },
            formularioTipo: this.userData?.typeForm,
        };
    }

    // ------------------------------------------------------------------
    // ETAPAS
    // ------------------------------------------------------------------

    /** Etapas desta solicitação: o cadastro e a assinatura só aparecem quando se aplicam. */
    public get steps(): IRequestStep[] {
        const triagem = this.userService.isTriagem();
        const steps: IRequestStep[] = [];

        if (this.needsRegistrationUpdate) {
            steps.push({ id: StepperPositionEnum.ATUALIZACAO_CADASTRAL, title: 'Seus dados', hint: 'Confirme o cadastro' });
        }

        steps.push(
            { id: StepperPositionEnum.INICIO, title: 'Serviço', hint: 'O que você precisa' },
            {
                id: StepperPositionEnum.REQUERENTE,
                title: triagem ? 'Requerente' : 'Para quem',
                hint: triagem ? 'Quem está sendo atendido' : 'Você ou outra pessoa',
            },
            { id: StepperPositionEnum.DETALHAMENTO, title: 'Detalhes', hint: 'Conte sobre o pedido' },
            { id: StepperPositionEnum.DOCUMENTOS, title: 'Documentos', hint: 'Anexe os arquivos' },
            { id: StepperPositionEnum.RESUMO, title: 'Revisão', hint: 'Confira antes de enviar' },
        );

        if (this.userData?.haveSign) {
            steps.push({ id: StepperPositionEnum.DOCUMENTO_SOLICITACAO, title: 'Assinatura', hint: 'Assine com gov.br' });
        }

        return steps;
    }

    public get currentStepIndex(): number {
        return Math.max(0, this.steps.findIndex((step) => step.id === this.selectedStep));
    }

    public get isLastStep(): boolean {
        const steps = this.steps;

        return steps[steps.length - 1]?.id === this.selectedStep;
    }

    public trackByStep(_: number, step: IRequestStep): number {
        return step.id;
    }

    /** Pela trilha lateral: volta a qualquer etapa e avança até onde já esteve, se estiver tudo em ordem. */
    public canVisit(step: StepperPositionEnum): boolean {
        if (step <= this.selectedStep) return true;
        if (step > this.maxReachedStep) return false;

        return this.steps
            .filter((item) => item.id >= this.selectedStep && item.id < step)
            .every((item) => !this.isStepBlocked(item.id));
    }

    public goToStep(step: StepperPositionEnum): void {
        if (step === this.selectedStep || !this.canVisit(step)) return;

        this.moveTo(step);
    }

    /**
     * Formulário de Alvará preenchido pelo contribuinte (a triagem usa o formulário padrão).
     */
    public get isAlvaraContribuinteForm(): boolean {
        return this.userData?.typeForm === typeFormRequestEnum.ALVARA && !this.userService.isTriagem();
    }

    public nextStep() {
        // Formulário dinâmico longo: "Continuar" percorre as partes internas antes de
        // avançar a etapa da solicitação.
        if (this.selectedStep === StepperPositionEnum.DETALHAMENTO && this.formDynamic?.goToNextPage()) {
            return;
        }

        // No Alvará o botão fica habilitado para destacar os campos obrigatórios vazios ao clicar
        if (this.selectedStep === StepperPositionEnum.DETALHAMENTO && this.formAlvara && !this.formAlvara.validateBeforeProceed()) {
            return;
        }

        if (this.enableNextStep) return;

        const steps = this.steps;
        const next = steps[steps.findIndex((step) => step.id === this.selectedStep) + 1];

        if (next) {
            this.moveTo(next.id);
        } else {
            this.save();
        }
    }

    private moveTo(step: StepperPositionEnum): void {
        this.entity = this.synchronizeDataWithChildrenComponent();

        if (step === StepperPositionEnum.DOCUMENTO_SOLICITACAO) {
            this.renderModalAccountLevel = true;
        }

        this.selectedStep = step;
        this.maxReachedStep = Math.max(this.maxReachedStep, step);

        if (this.selectedStep > StepperPositionEnum.DETALHAMENTO) this.renderPdf();

        this.scrollToTop();
    }

    private scrollToTop(): void {
        const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    }

    /** Sai da solicitação para a lista de onde o usuário veio. */
    public exit(): void {
        if (this.userService.isCidadao()) {
            this.global.router.navigate(['/citizen']);
        } else if (this.userService.isTriagem()) {
            this.global.router.navigate(['/requests/evaluation']);
        } else {
            this.global.router.navigate(['/requests/ongoing']);
        }
    }

    public get exitLabel(): string {
        return this.userService.isCidadao() ? 'Minhas solicitações' : 'Solicitações';
    }

    /** Título e explicação da etapa atual, no topo do cartão. */
    public get stepHeading(): { title: string; description: string } {
        const triagem = this.userService.isTriagem();

        switch (this.selectedStep) {
            case StepperPositionEnum.ATUALIZACAO_CADASTRAL:
                return { title: 'Confirme seus dados', description: 'Antes de começar, confira se o seu cadastro está em dia.' };
            case StepperPositionEnum.INICIO:
                return {
                    title: 'Qual serviço você precisa?',
                    description: 'Busque pelo nome ou navegue pelos órgãos. Na dúvida, tente uma palavra só, como “férias” ou “IPTU”.',
                };
            case StepperPositionEnum.REQUERENTE:
                return triagem
                    ? { title: 'Quem está sendo atendido?', description: 'Informe os dados de quem procurou o atendimento.' }
                    : { title: 'Para quem é a solicitação?', description: 'Diga se o pedido é seu ou de alguém que você representa.' };
            case StepperPositionEnum.DETALHAMENTO:
                return {
                    title: this.userData?.digitalForm?.AFR_Titulo || 'Conte os detalhes',
                    description: 'Quanto mais claro o pedido, mais rápida a análise. Os campos com * são obrigatórios.',
                };
            case StepperPositionEnum.DOCUMENTOS:
                return { title: 'Anexe os documentos', description: 'Os obrigatórios estão marcados. Confira a lista antes de continuar.' };
            case StepperPositionEnum.RESUMO:
                return { title: 'Revise antes de enviar', description: 'Confira cada parte. Se precisar corrigir algo, use “Alterar”.' };
            case StepperPositionEnum.DOCUMENTO_SOLICITACAO:
                return {
                    title: 'Assine o requerimento',
                    description: 'Geramos o documento com as suas respostas. Confira, posicione a assinatura e assine com sua conta gov.br.',
                };
            default:
                return { title: '', description: '' };
        }
    }

    public get continueLabel(): string {
        if (this.selectedStep === StepperPositionEnum.DETALHAMENTO && this.formDynamic?.hasNextPage) return 'Próxima parte';
        if (this.selectedStep === StepperPositionEnum.RESUMO && this.userData?.haveSign) return 'Continuar para assinatura';

        return 'Continuar';
    }

    /** O botão de continuar está desabilitado: diz por quê, ao lado dele. */
    public get blockedReason(): string | null {
        switch (this.selectedStep) {
            case StepperPositionEnum.INICIO:
                return this.userData?.servicePendingReason || null;
            case StepperPositionEnum.REQUERENTE:
                return this.userData?.applicantPendingReason || null;
            case StepperPositionEnum.DETALHAMENTO:
                if (this.isDynamicForm) return this.formDynamic?.pendingHint || null;
                return this.enableNextStep ? 'Preencha os campos obrigatórios e aceite o termo de veracidade.' : null;
            case StepperPositionEnum.DOCUMENTOS:
                return this.attachmentsRequest?.pendingReason || null;
            case StepperPositionEnum.DOCUMENTO_SOLICITACAO:
                return this.saveDocumentData ? null : 'Assine o documento com sua conta gov.br para enviar.';
            default:
                return null;
        }
    }

    private synchronizeDataWithChildrenComponent() {
        let solDescricao = '';

        if (this.global.showForms) {
            solDescricao = this.entity.formulariosDTI?.formVariants?.SOL_Descricao ||
                this.entity.formulariosDTI?.SOL_Descricao;
        } else {
            solDescricao = this.entity.formularios?.SOL_Descricao ||
                this.entity.formularios?.formVariants?.SOL_Descricao;
        }

        return {
            ...this.entity,
            applicantRequest: this.userData?.form?.get('applicantRequest')?.value,
            telefone: this.userData?.form.get('PE_Telefone')?.value,
            solicitacao: {
                ...this.entity.solicitacao,
                SOL_CodigoOrgao: this.userData?.solicitacaoFormGroup.get('SOL_CodigoOrgao').value,
                SOL_CodigoAssunto: this.userData?.solicitacaoFormGroup.get('SOL_CodigoAssunto').value,
                SOL_CodigoSolicitante: this.userData?.solicitacaoFormGroup.get('SOL_CodigoSolicitante').value,
                SOL_Status: 0,
                SOL_Descricao: this.resolveRequestDescription(solDescricao),
                SOL_CodigoDocumento: null,
                SOLH_Historico: 'A solicitação está em análise',
            },
            requerente: {
                ...this.entity.requerente,
                ...this.userData?.requerenteFormGroup?.getRawValue(),
            },
            documentos: {
                procuracao: this.userData?.form.get("procuracao")?.value || [],
                requerimento: this.attachmentsRequest?.entity.documentos.requerimento || [],
                complementar: this.attachmentsRequest?.entity.documentos.complementar || [],
            },
            formularioTipo: this.userData?.typeForm,
        };
    }

    public previousStep() {
        if (this.selectedStep === StepperPositionEnum.DETALHAMENTO && this.formDynamic?.goToPreviousPage()) {
            return;
        }

        const steps = this.steps;
        const previous = steps[steps.findIndex((step) => step.id === this.selectedStep) - 1];

        if (previous) {
            this.moveTo(previous.id);
        } else {
            this.exit();
        }
    }

    openSwal(text: string) {
        this.swal.fire({
            title: 'Atenção!',
            text: text,
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: 'Ok',
        });
    }

    /** Troca manual de serviço: os anexos e as respostas do formulário digital eram do anterior. */
    public onSubjectChanged(): void {
        this.attachmentsRequest?.resetDocuments();
        this.formDynamic?.clearLocalStorage();
    }

    /**
     * Apaga o rascunho inteiro pelas chaves, e não pelos componentes: o formulário de um
     * serviço escolhido antes (e trocado) não está mais na tela, mas o rascunho dele ficou.
     */
    private clearDraftStorage(): void {
        REQUEST_DRAFT_KEYS.forEach(key => localStorage.removeItem(key));
    }

    public clearDraft() {
        this.swal.fire({
            title: 'Limpar rascunho?',
            text: 'Todos os dados preenchidos e arquivos anexados nesta solicitação serão descartados.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, limpar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#f5365c',
        }).then((result) => {
            if (!result.isConfirmed) return;

            this.clearDraftStorage();

            // recarregar reinicia todos os passos, formulários e dropzones de uma vez
            window.location.reload();
        });
    }

    /*
     * Função que valida se todos os campos estão preenchidos corretamente.
     * Recebe um objeto com os campos obrigatórios de cada step
     */

    areFieldsFilled(fieldsObject: any): boolean {
        for (let field in fieldsObject) {
            if (fieldsObject[field] == null || fieldsObject[field] == 'null' || fieldsObject[field] == '') {
                return false;
            }
        }
        return true;
    }

    /*
     * Função que lida com o segundo step (Cadastro de Requerente)
     * Os campos são preenchidos ou nulos de acordo com a marcação do checkbox "solicitar para outra Pessoa"
     */

    toggleCheckTerm() {
        this.termAccepted = !this.termAccepted;
    }

    public save() {
        this.global.startLoading('Enviando solicitação...', true);
    
        if (this.entity.requerente) {
            this.entity.requerente.SOLR_TipoInscricao = parseInt(this.entity.requerente.SOLR_TipoInscricao);
        }
    
        let solicitacao = { ...this.entity };
    
        solicitacao.formularios = { ...this.entity.formularios };
        solicitacao.formulariosDTI = { ...this.entity.formulariosDTI };
    
        // As respostas do formulário digital seguem em campo próprio, montado antes
        // de formVariants ser removido da cópia enviada.
        if (this.isDynamicForm) {
            solicitacao.formularioDigital = this.buildDynamicSubmission();
        }
    
        if (solicitacao.formularios?.formVariants) {
            delete solicitacao.formularios.formVariants;
        }
    
        if (solicitacao.formulariosDTI?.formVariants) {
            delete solicitacao.formulariosDTI.formVariants;
        }
    
        this.requestService.save(solicitacao).subscribe({
            next: (response: any) => {
                this.requestCode = response.entity.SOL_CodigoSolicitacao;
                this.requestSaved = true;
                this.clearDraftStorage();

                this.global.closeModalInfo('Documentos');

                // A confirmação aparece na hora; o número chega com a solicitação gravada.
                this.submitted = { id: this.requestCode, numero: null, entity: null };
                this.scrollToTop();

                this.requestService.getEntity(response.entity.SOL_CodigoSolicitacao).subscribe({
                    next: (data: any) => {
                        if (this.entity.requerente) {
                            this.entity.requerente.SOLR_CodigoSolicitacao = response.entity.SOL_CodigoSolicitacao;
                        }
                        this.submitted = {
                            id: this.requestCode,
                            numero: data?.entity?.SOL_NumeroSolicitacao
                                ? `${data.entity.SOL_NumeroSolicitacao}/${data.entity.SOL_AnoSolicitacao}`
                                : null,
                            entity: data?.entity || null,
                        };
                        this.global.stopLoading();
                    },
                    error: () => this.global.stopLoading(),
                });
            },
            error: (err) => {
                this.requestSaved = false;
                this.global.stopLoading();

                if (err?.error?.code === 'E_DIGITAL_FORM_OUTDATED') {
                    this.handleOutdatedDynamicForm(err.error.message);
                    return;
                }

                this.global.swal.fire({
                    title: 'Não foi possível enviar a solicitação',
                    text: err?.error?.message || 'Tente novamente em instantes.',
                    icon: 'error',
                });
            }
        });
    }

    saveTriagemTermo() {
        if (!this.termScreeningAccepted) {
            this.termScreeningAccepted = true;

            const termo = {
                TT_CodigoUsuario: this.global.user().USR_CodigoUsuario,
                TT_Aceito: true,
            };

            this.evaluationTermService.save(termo).subscribe({
                next: () => {
                    this.global.closeModalInfo(this.modalName + '-termo');
                    this.entity.checkBoxMarked = true;
                },
            });
        }
    }

    getFormRequest(event) {
        this.entity.formularios = event.form;
        this.validateForm = event.validators;
        this.dynamicPageValid = event.pageValid ?? event.validators;
    }

    getFormDTIRequest(event: { form: any; validators: boolean }) {
        this.entity.formulariosDTI = event.form;
        this.validateForm = event.validators;
    }

    getEnumType(type: string): number {
        return typeFormRequestEnum[type];
    }

    renderPdfIptu() {
        const dataPDF = {
            subject: this.userData?.subjectName,
            org: this.userData?.orgao?.OR_Descricao,
            solicitante: this.entity.requerente,
            form: this.entity.formularios,
            description: this.entity.solicitacao.SOL_Descricao,
        };
        this.documentForm = this.documentFormService.generatorDocumentFormIptuPDF(dataPDF);
    }

    public renderPdfSEAD() {
        delete this.entity.formularios?.termoAceito;

        const contentRequerente = [
            {
                title: 'REQUERENTE: ',
                content:
                    this.documentFormService.formatCpfCnpj(this.entity.requerente.SOLR_CpfCnpj) +
                    ' - ' +
                    this.entity.requerente.SOLR_NomeRazaoSocial,
            },
            {
                title: 'TELEFONE: ',
                content: this.documentFormService.formatTelefone(this.entity.formularios.SOLS_RequerenteTelefone),
            },
            { title: 'RG: ', content: this.mascaraRg(this.entity.formularios.SOLS_RequerenteRG) },
            { title: 'ÓRGÃO EXPEDITOR: ', content: this.entity.formularios.SOLS_RequerenteRGOrgaoExpeditor },
            {
                title: 'DATA DE NASCIMENTO: ',
                content: this.documentFormService.formatData(this.entity.formularios.SOLS_RequerenteDataNascimento),
            },
            {
                title: 'ENDEREÇO: ',
                content:
                    this.entity.formularios.SOLS_RequerenteLogradouro +
                    ', ' +
                    this.entity.formularios.SOLS_RequerenteNumero +
                    ', ' +
                    this.entity.formularios.SOLS_RequerenteBairro +
                    ', ' +
                    this.entity.formularios.SOLS_RequerenteMunicipio +
                    ' - ' +
                    this.documentFormService.formatCEP(this.entity.formularios.SOLS_RequerenteCEP),
            },
        ];

        const contentLotacaoCargo = [
            { title: 'LOTAÇÃO: ', content: this.entity.formularios?.SOLS_RequerenteLotacao },
            { title: 'CARGO: ', content: this.entity.formularios?.SOLS_RequerenteCargo },
        ];

        const content = [
            { title: 'UNIDADE DE EXERCÍCIO: ', content: this.entity.formularios?.SOLS_RequerenteUnidadeExercicio },
            {
                title: 'DATA EF.EXERCÍCIO/ADM: ',
                content: this.documentFormService.formatData(this.entity.formularios?.SOLS_RequerenteDataExercicio),
            },
        ];

        const autoridadesLabels = {
            [AutoridadeEnum.SECRETARIO_INFRAESTRUTURA]: 'Secretário(a) de Infraestrutura',
            [AutoridadeEnum.SECRETARIO_EDUCACAO]: 'Secretário(a) de Educação',
            [AutoridadeEnum.SECRETARIO_REGEGIONAL_PECEM]: 'Secretário(a) Regional Pecém',
            [AutoridadeEnum.PREFEITO_MUNICIPAL]: 'Prefeito Municipal',
            [AutoridadeEnum.OUVIDOR]: 'Ouvidor(a)',
            [AutoridadeEnum.SECRETARIO_SAUDE]: 'Secretário(a) de Saúde',
            [AutoridadeEnum.CONTROLADOR]: 'Controlador(a)',
            [AutoridadeEnum.SECRETARIO_ADMINISTRACAO]: 'Secretário(a) de Administração',
            [AutoridadeEnum.SECRETARIO_GOVERNO]: 'Secretário(a) de Governo',
            [AutoridadeEnum.SECRETARIO_TRABALHO_SOCIAL]: 'Secretário(a) de Trab. e Des.Social',
            [AutoridadeEnum.PROCURADOR_GERAL]: 'Procurador(a) Geral',
            [AutoridadeEnum.SECRETARIO_GERAL]: 'Secretário(a) Geral',
            [AutoridadeEnum.SECRETARIO_FINANCAS]: 'Secretário(a) de Finanças',
            [AutoridadeEnum.COORDENADOR_FMPS]: 'Coordenador(a) do FMPS',
            [AutoridadeEnum.OUTROS]: 'Outros',
        };

        const contentBeneficiario = [
            {
                title: 'PARENTESCO COM EX-SERVIDOR: ',
                content: this.entity.formularios.SOLS_RequerenteParentescoExServidor,
            },
            {
                title: 'DATA DO ÓBITO: ',
                content: this.entity.formularios?.SOLS_RequerenteDataObito
                    ? this.documentFormService.formatData(this.entity.formularios?.SOLS_RequerenteDataObito)
                    : null,
            },
            {
                title: 'AUTORIDADE REQUERIDA: ',
                content: autoridadesLabels[this.entity.formularios?.SOLS_RequerenteAutoridadeRequerida],
            },
        ];

        const data: any[] = [
            {
                title: 'DADOS DO SOLICITANTE',
                contents: [
                    {
                        title: 'SOLICITANTE: ',
                        content:
                            this.documentFormService.formatCpfCnpj(this.global.user().PE_CPF) +
                            ' - ' +
                            this.global.user().PE_Nome,
                    },
                    { title: 'E-MAIL: ', content: this.global.user().PE_Email },
                ],
            },
            {
                title: 'DADOS DA SOLICITAÇÃO',
                contents: [
                    { title: 'ORGÃO: ', content: 'SEAD' },
                    { title: 'ASSUNTO: ', content: this.userData?.subjectName },
                ],
            },
            {
                title: 'DADOS DO REQUERENTE',
                contents: contentRequerente.filter((content) => content.content),
                height: null,
                columns: 1,
            },
        ];

        if (contentLotacaoCargo?.filter((content) => content?.content?.length > 0)?.length > 0) {
            data.push({
                title: null,
                contents: contentLotacaoCargo.filter((content) => content.content),
            });
        }

        if (content?.filter((content) => content?.content?.length > 0)?.length > 0) {
            data.push({
                title: null,
                contents: content.filter((content) => content.content),
            });
        }

        if (contentBeneficiario?.filter((content) => content?.content?.length > 0)?.length > 0) {
            data.push({
                title: null,
                contents: contentBeneficiario.filter((content) => content.content),
                height: null,
                columns: 2,
            });
        }

        data.push({
            title: null,
            contents: [
                {
                    title: null,
                    content:
                        'Declaro, para fins de direito, sob as penas da lei, que as informações acima prestadas e documentos são verdadeiros e autênticos. Atesto que estou ciente de que, se constatada falsidade ideológica ou documental, responderei civil e criminalmente, na forma do art. 299 e seguinte do código penal.',
                },
            ],
        });
        this.documentForm = this.documentFormService.generatorDocumentFormSEAD(data);
    }

    renderPdfInscricao() {
        const dataPDF = {
            subject: this.userData?.subjectName,
            org: this.userData?.orgao?.OR_Descricao,
            solicitante: this.entity.requerente,
            form: this.entity.formularios,
            description: this.entity.solicitacao.SOL_Descricao,
        };
        this.documentForm = this.documentFormService.generatorDocumentFormInscricao(dataPDF);
    }

    renderPdfDefault() {
        this.documentForm = this.documentFormService.generateDocumentFormDefault({
            solicitante: this.userData?.user,
            assunto: this.userData?.subjectName,
            orgao: this.userData?.orgao.OR_Descricao,
            description: this.entity.solicitacao.SOL_Descricao,
            applicantRequest: this.entity.applicantRequest,
            requerente: this.entity?.requerente,
        });
    }

    private mascaraRg(v) {
        v = v.replace(/\D/g, '');
        v = v.replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/, '$1$2$3-$4');
        return v;
    }

    openDocumentModal() {
        this.global.showModalInfo('Documentos');
    }

    saveDocumentAndSignature(event) {
        const date = new Date();

        // No formulário dinâmico o PDF assinado segue em formularioDigital e o servidor
        // o anexa junto com o requerimento; nos demais, vai como anexo da solicitação.
        if (this.isDynamicForm) {
            this.dynamicSignedFile = {
                anexo: event.fileCloudFlare,
                nomeAnexo: `${this.documentForm?.pdfFileName || 'requerimento'}.pdf`,
            };
        } else {
            this.entity.documentos["requerimento"].push({
                url: event.fileCloudFlare,
                name: event.fileCloudFlare,
                type: "application/pdf",
                typeDocument: "REQUERIMENTO"
            })
        }

        this.saveDocumentData = {
            documentSave: {
                DOC_Assunto: this.userData?.subjectName,
                DOC_Exercicio: date.getFullYear(),
                DOC_Tipo: 'solicitacao',
                DOC_CodigoUsuario: this.global.user().USR_CodigoUsuario,
                DOC_Conteudo: event.fileCloudFlare,
                DOC_DocumentoBase64: event.base64Document,
                DOC_Hash: event.hash,
            },
            documentSignature: {
                DOCSIGN_CodigoPessoa: this.entity.solicitacao.SOL_CodigoSolicitante,
                DOCSIGN_Assinatura: event.fileCloudFlare,
                DOCSIGN_Certificado: event.cert
            },
            subscribers: [
                {
                    DOCAS_CodigoAssinante: this.global.user().USR_CodigoUsuario,
                },
            ],
        };
    }

    saveDocumentAndRequest() {
        this.global.startLoading('Salvando documento...', true);
        this.documentService.saveSignDocument(this.saveDocumentData).subscribe({
            next: (response: any) => {
                const documentId = response.result.id;
                this.entity.solicitacao.SOL_CodigoDocumento = documentId;
                this.global.stopLoading();
                this.save();
            },
        });

    }

    renderPdfITBI() {
        this.entity.solicitacao.SOL_Descricao = this.entity.formularios['formVariants'].SOL_Descricao;
        const dataPDF = {
            subject: this.userData?.subjectName,
            org: this.userData?.orgao?.OR_Descricao,
            solicitante: this.entity.requerente,
            form: this.entity.formularios,
            description: this.entity.solicitacao.SOL_Descricao,
        };
        this.documentForm = this.documentFormService.generatorDocumentFormITBI(dataPDF);
    }


    renderPdfAlvara() {
        this.entity.solicitacao.SOL_Descricao = this.entity.formularios['formVariants'].SOL_Descricao;
        const dataPDF = {
            subject: this.userData?.subjectName,
            org: this.userData?.orgao?.OR_Descricao,
            solicitante: this.entity.requerente,
            form: this.entity.formularios,
            description: this.entity.solicitacao.SOL_Descricao,
            usuarioLogado: {
                SOLR_CpfCnpj: this.global.user().PE_CPF,
                SOLR_NomeRazaoSocial: this.global.user().PE_Nome,
                SOLR_Email: this.global.user().PE_Email,
                SOLR_Telefone: this.global.user().PE_Telefone1
            }
        };
        this.documentForm = this.documentFormService.generatorDocumentFormAlvara(dataPDF);
    }

    renderPdfDTI() {
        const dataPDF = {
            subject: this.userData?.subjectName,
            org: this.userData?.orgao?.OR_Descricao,
            solicitante: this.entity.requerente,
            form: this.entity.formulariosDTI,
            description: this.entity.formulariosDTI?.formVariants?.SOL_Descricao,
        };
        this.documentForm = this.documentFormService.generatorDocumentFormITBI(dataPDF);
    }

    /** A etapa atual ainda não permite continuar (o nome ficou do stepper antigo). */
    public get enableNextStep() {
        return this.isStepBlocked(this.selectedStep, true);
    }

    /**
     * @param current a etapa é a que está na tela: no formulário dinâmico conta só a parte
     * visível; vista pela trilha lateral, conta o formulário inteiro.
     */
    public isStepBlocked(step: StepperPositionEnum, current = false): boolean {
        switch (step) {
            case StepperPositionEnum.ATUALIZACAO_CADASTRAL:
                if (!this.updateRegistrationUser?.isDisabled) {
                    return false;
                }
                return true;

            case StepperPositionEnum.INICIO:
                return !!this.userData?.servicePendingReason;

            case StepperPositionEnum.REQUERENTE:
                return !!this.userData?.form?.invalid;

            case StepperPositionEnum.DETALHAMENTO:
                // No formulário dinâmico vale a validade da parte atual: as demais só
                // precisam estar preenchidas quando o cidadão chegar nelas.
                if (this.isDynamicForm) {
                    return current ? !this.dynamicPageValid : !this.validateForm;
                }

                // O Alvará mantém o botão habilitado de propósito: a validação acontece em
                // nextStep(), para destacar de uma só vez todos os obrigatórios não preenchidos
                if (this.isAlvaraContribuinteForm) {
                    return false;
                }

                if (this.global.showForms) {
                    if ((this.entity?.formularioTipo === typeFormRequestEnum.ALVARA || this.entity?.formularioTipo === typeFormRequestEnum.SEMURB) && !this.userService.isTriagem()) {
                        return !this.validateForm;
                    } else {
                        return !!this.formDefault?.form?.invalid;
                    }
                } else {
                    return !this.validateForm;
                }
            case StepperPositionEnum.DOCUMENTOS:
                return !this.attachmentsRequest?.isAttached;

            default:
                return false;
        }
    }

    public renderPdf() {
        // O formulário dinâmico gera no servidor e liga havePdfBuffer no retorno.
        if (this.isDynamicForm) {
            this.renderPdfDinamico();
            return;
        }

        if (!this.global.showForms) {
            switch (this.entity?.formularioTipo) {
                case typeFormRequestEnum.IPTU:
                    this.renderPdfIptu();
                    break;
                case typeFormRequestEnum.SEAD:
                    this.renderPdfSEAD();
                    break;
                case typeFormRequestEnum.INSCRICAO:
                    this.renderPdfInscricao();
                    break;
                case typeFormRequestEnum.ITBI:
                    this.renderPdfITBI();
                    break;
                case typeFormRequestEnum.SEMURB:
                    this.openIframeSEMURB();
                    break;
                case typeFormRequestEnum.ALVARA:
                    this.renderPdfAlvara();
                    break;
                case typeFormRequestEnum.DTI:
                    this.renderPdfDTI();
                    break;
                default:
                    this.renderPdfDefault();
                    break;
            }
        }
        else {
            if (this.entity?.formularioTipo === typeFormRequestEnum.ALVARA && !this.userService.isTriagem()) {
                this.renderPdfAlvara();
            }
            else if (this.entity?.formularioTipo === typeFormRequestEnum.SEMURB && !this.userService.isTriagem()) {
                this.openIframeSEMURB();
            } else {
                this.renderPdfDefault();
            }
        }

        // Sem documento não há o que assinar: o componente de assinatura só é criado com
        // o PDF pronto, em vez de abrir uma etapa "Documento" em branco.
        this.havePdfBuffer = !!this.documentForm;
    }

    // ------------------------------------------------------------------
    // FORMULÁRIO DIGITAL DINÂMICO
    // ------------------------------------------------------------------

    private get isDynamicForm(): boolean {
        return this.entity?.formularioTipo === typeFormRequestEnum.DINAMICO;
    }

    /** Onde o cidadão assina no requerimento digital: o marcador de assinatura já começa ali. */
    public get citizenSignaturePosition(): IDigitalFormSignaturePosition | null {
        return this.isDynamicForm ? this.dynamicPreview?.requerenteSignaturePosition || null : null;
    }

    /**
     * Solicitação aberta pela triagem com formulário que exige o responsável: no lugar
     * do "Aprovar e Tramitar", ela é encaminhada para assinatura.
     */
    public get requiresSignatureForwarding(): boolean {
        return this.isDynamicForm && this.userData?.digitalForm?.AFR_ExigeAssinaturaResponsavel === true;
    }

    public onForwardedToSigners(message: string): void {
        this.global.swal
            .fire({
                title: 'Encaminhado para assinatura',
                text: message || 'A solicitação foi encaminhada para a assinatura do responsável.',
                icon: 'success',
                confirmButtonColor: '#2563eb',
            })
            .then(() => this.global.router.navigate(['/requests/evaluation']));
    }

    /**
     * Descrição da solicitação. O formulário dinâmico não tem um campo fixo para
     * isso, então o título do próprio formulário faz esse papel.
     */
    private resolveRequestDescription(descricaoPadrao: string): string {
        if (this.isDynamicForm) {
            return this.userData?.digitalForm?.AFR_Titulo || this.userData?.subjectName || '';
        }

        return descricaoPadrao;
    }

    /** Campos e respostas na ordem do formulário, para conferência no passo Resumo. */
    public get dynamicSummary(): Array<{ nome: string; valor: string | null }> {
        if (!this.isDynamicForm) return [];

        const respostas = this.buildDynamicAnswers();

        return (this.userData?.digitalForm?.campos || []).map((campo) => {
            const bruto = respostas[String(campo.AFC_CodigoCampo)];
            const vazio = bruto === null || bruto === undefined || String(bruto).trim() === '';
            const data = campo.AFC_Tipo === DigitalFormFieldTypeEnum.DATA && /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(bruto));

            return {
                nome: campo.AFC_Nome,
                valor: vazio ? null : data ? `${data[3]}/${data[2]}/${data[1]}` : String(bruto),
            };
        });
    }

    /** Respostas do formulário dinâmico, indexadas pelo código do campo. */
    private buildDynamicAnswers(): Record<string, any> {
        const { termoAceito, ...respostas } = this.entity?.formularios?.['formVariants'] || {};

        return respostas;
    }

    /**
     * Dados do formulário que seguem com a solicitação. O servidor confere a versão
     * antes de gravar, para que o snapshot seja o mesmo documento que foi assinado.
     */
    private buildDynamicSubmission(): IDigitalFormSubmission {
        const formulario = this.userData?.digitalForm;

        return {
            formularioId: this.dynamicPreview?.formularioId ?? formulario?.AFR_CodigoFormulario,
            versao: this.dynamicPreview?.versao ?? formulario?.AFR_Versao,
            respostas: this.buildDynamicAnswers(),
            assinatura: this.dynamicSignedFile
                ? {
                      ...this.dynamicSignedFile,
                      responsavelSignaturePosition: this.dynamicPreview?.responsavelSignaturePosition || null,
                  }
                : null,
        };
    }

    private base64ToArrayBuffer(base64: string): ArrayBuffer {
        const binary = window.atob(base64);
        const bytes = new Uint8Array(binary.length);

        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }

        return bytes.buffer;
    }

    /**
     * Gera no servidor o PDF que o cidadão assina. Só acontece ao chegar na etapa de
     * assinatura, que é onde o documento aparece — e onde uma falha faz sentido.
     * Se as respostas mudaram desde a última geração, a assinatura anterior deixa de
     * valer e precisa ser refeita.
     */
    private renderPdfDinamico(): void {
        const assuntoId = Number(this.userData?.solicitacaoFormGroup.get('SOL_CodigoAssunto').value);
        const naEtapaDeAssinatura = this.selectedStep === StepperPositionEnum.DOCUMENTO_SOLICITACAO;

        if (!assuntoId || !this.userData?.haveSign || !naEtapaDeAssinatura) return;

        const respostas = this.buildDynamicAnswers();
        const representado = this.dynamicRepresentado();
        const telefone = this.userData?.form?.get('PE_Telefone')?.value || null;
        const key = JSON.stringify({ assuntoId, respostas, representado, telefone });

        if (key === this.dynamicPdfKey && this.documentForm) return;

        this.resetDynamicSignature();
        this.dynamicPdfKey = key;
        this.global.startLoading('Gerando requerimento...', true);

        this.digitalFormService
            .prepareSign(assuntoId, respostas, representado, telefone)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.dynamicPreview = response;
                    this.documentForm = {
                        pdfBase64: response.pdfBase64,
                        pdfBuffer: this.base64ToArrayBuffer(response.pdfBase64),
                        pdfFileName: response.fileName,
                    };
                    this.havePdfBuffer = true;
                    this.global.stopLoading();
                },
                error: (err) => {
                    this.dynamicPdfKey = null;
                    this.global.stopLoading();

                    // Mensagens de regra do formulário vêm prontas do servidor; qualquer
                    // outra falha é técnica e não deve chegar crua ao cidadão.
                    const mensagemDoFormulario = String(err?.error?.code || '').startsWith('E_DIGITAL_FORM');

                    this.global.swal
                        .fire({
                            title: 'Não foi possível gerar o requerimento',
                            text: mensagemDoFormulario
                                ? err.error.message
                                : 'O documento não pôde ser gerado agora. Tente novamente em instantes.',
                            icon: 'error',
                            showCancelButton: true,
                            confirmButtonText: 'Tentar novamente',
                            cancelButtonText: 'Fechar',
                        })
                        .then((result) => {
                            if (result.isConfirmed) this.renderPdfDinamico();
                        });
                },
            });
    }

    /**
     * Quem está sendo representado, com os dados preenchidos na etapa "Para quem". O
     * requerimento traz os dois: o representado como requerente e quem abre a solicitação
     * (e assina) como solicitante. Sem representação, o pedido é do próprio usuário.
     */
    private dynamicRepresentado(): IDigitalFormRepresentado | null {
        if (!this.userData?.representing) return null;

        const requerente = this.userData.requerenteFormGroup?.getRawValue() || {};

        return {
            nome: requerente.SOLR_NomeRazaoSocial || '',
            documento: requerente.SOLR_CpfCnpj || null,
            tipo: this.tipoInscricaoLabel(requerente.SOLR_TipoInscricao),
            email: requerente.SOLR_Email || null,
            telefone: requerente.SOLR_Telefone || null,
        };
    }

    /** Descarta PDF e assinatura: o componente de assinatura é recriado do zero. */
    private resetDynamicSignature(): void {
        this.dynamicPreview = null;
        this.dynamicSignedFile = null;
        this.documentForm = null;
        this.saveDocumentData = null;
        this.havePdfBuffer = false;
    }

    /**
     * O administrador alterou o formulário enquanto o cidadão preenchia. As respostas
     * não valem para a nova estrutura: recarrega o formulário e volta ao detalhamento.
     */
    private handleOutdatedDynamicForm(message: string): void {
        this.global.swal
            .fire({ title: 'Formulário atualizado', text: message, icon: 'info', confirmButtonText: 'Revisar formulário' })
            .then(() => {
                this.resetDynamicSignature();
                this.dynamicPdfKey = null;
                this.userData?.setSubjectNameAndAttachments();

                if (this.selectedStep > StepperPositionEnum.DETALHAMENTO) {
                    this.moveTo(StepperPositionEnum.DETALHAMENTO);
                }
            });
    }

    public getcheckFormType(type: number) {
        return this.userData?.form?.get('typeForm').value == typeFormRequestEnum[type];
    }

    public checkMask(value: string): string {
        const valueSize = value?.length;
        if (valueSize == 11) {
            return '000.000.000-00'
        }
        return "00.000.000/0000-00"
    }

    public get saveRequestRule() {
        return this.selectedStep == StepperPositionEnum.RESUMO && !this.userData?.haveSign
    }

    openIframeSEMURB() {
        const dataPDF = {
            subject: this.userData?.subjectName,
            org: this.userData?.orgao?.OR_Descricao,
            solicitante: this.entity.solicitante,
            requerente: this.entity.requerente,
            form: this.entity.formularios,
            description: this.entity.solicitacao.SOL_Descricao,
        };

        this.documentForm = this.documentFormService.generateDocumentFormSemurb(dataPDF);

        this.global.showModalInfo('Documentos');
    }

    async saveProcess() {
        this.process.PRC_CodigoSolicitacao = this.requestCode;
        this.process.PRCH_Historico = 'O processo foi criado';
        this.global.startLoading('Processando...', true);
        this.process.SOL_Autorizante = this.global.user().USR_CodigoUsuario;
    
        this.proccessService.save(this.process).subscribe({
            next: async () => {
                this.global.stopLoading();
                await this.global.router.navigate(['/process/all']);
                this.global.closeModalInfo(this.modalName);
                window.location.reload();
            },
        });
    }

    getDepartments() {
        this.departmentService.listAll(`"DEP_CodigoOrgao" = ${this.entity.solicitacao.SOL_CodigoOrgao}`, 0).pipe(takeUntil(this.destroy$)).subscribe({
            next: (response: IListScopeDepartmentResponse) => {
                this.departments = response.data.filter(dep =>
                    dep.DEP_TipoProcessoAceito === 1 || dep.DEP_TipoProcessoAceito === 3
                );

                const subjectDepartment = this.userData?.subjectDepartmentCode;

                if (subjectDepartment) {
                    this.process.department = String(subjectDepartment);
                }
            },
        });
    }

    verifyRegistrationUser() {
        let savedDate = moment(this.userService.getUser().PE_UltimaAtualizacaoCadastral, 'YYYY-MM-DD');
        if (!this.userService.getUser().PE_UltimaAtualizacaoCadastral) savedDate = moment("2000-01-01",'YYYY-MM-DD');

        const threeMonthsLater = savedDate.add(3, 'months');
        const now = moment()

        if (now.isSameOrAfter(threeMonthsLater)) {
            this.needsRegistrationUpdate = true;
            this.selectedStep = StepperPositionEnum.ATUALIZACAO_CADASTRAL;
            this.updateRegistrationData = this.userService.getUser();
        }
    }

    // ------------------------------------------------------------------
    // REVISÃO E CONFIRMAÇÃO
    // ------------------------------------------------------------------

    public tipoInscricaoLabel(value: any): string {
        switch (String(value)) {
            case '1':
                return 'Pessoa jurídica';
            case '3':
                return 'Órgão fiscalizador';
            default:
                return 'Pessoa física';
        }
    }

    /** Arquivos anexados, na ordem da etapa de documentos, para a revisão. */
    public get reviewFiles(): Array<{ tipo: string; nome: string }> {
        const documentos = this.entity?.documentos || {};
        const arquivos: Array<{ tipo: string; nome: string }> = [];

        (documentos.procuracao || []).forEach((file) => arquivos.push({ tipo: 'Procuração', nome: file?.name }));
        (documentos.requerimento || []).forEach((file) => arquivos.push({ tipo: file?.typeDocument, nome: file?.name }));
        (documentos.complementar || []).forEach((file) => arquivos.push({ tipo: 'Complementar', nome: file?.name }));

        return arquivos.filter((arquivo) => arquivo.nome);
    }

    public get reviewPhone(): string | null {
        return this.global.user()?.PE_Telefone1 || this.userData?.form?.get('PE_Telefone')?.value || null;
    }

    public get submittedDate(): Date {
        return this.submitted?.entity?.SOL_DataSolicitacao ? new Date(this.submitted.entity.SOL_DataSolicitacao) : new Date();
    }

    /** O requerimento digital também passa pela assinatura do responsável do órgão. */
    public get requiresResponsibleSignature(): boolean {
        return this.isDynamicForm && this.userData?.digitalForm?.AFR_ExigeAssinaturaResponsavel === true;
    }

    public openSubmittedRequest(): void {
        if (!this.submitted) return;

        const id = this.cryptoService.encrypt(String(this.submitted.id));
        this.global.router.navigate([`/requests/view/${id}`]);
    }

    public downloadReceipt(): void {
        if (this.submitted?.entity) {
            this.requestService.generateRequestPDF(this.submitted.entity);
        }
    }

    public copyProtocol(): void {
        if (!this.submitted?.numero || !navigator?.clipboard) return;

        navigator.clipboard.writeText(this.submitted.numero).then(() => {
            this.protocolCopied = true;
            setTimeout(() => (this.protocolCopied = false), 2000);
        });
    }

    // ------------------------------------------------------------------
    // RESUMO (coluna da direita)
    // ------------------------------------------------------------------

    public orgIcon(descricao: string): string {
        return orgIcon(descricao);
    }

    /** Para quem é a solicitação, como o cidadão reconhece. */
    public get summaryRequester(): string | null {
        if (!this.userData) return null;
        if (!this.userData.representing) return 'Para você';

        return this.userData.requerenteFormGroup?.get('SOLR_NomeRazaoSocial')?.value || 'Outra pessoa ou empresa';
    }

    public get summaryDocuments(): string | null {
        if (!this.userData?.selectedService || !this.attachmentsRequest) return null;

        const total = this.attachmentsRequest.requiredTypes.length;

        return total ? `${this.attachmentsRequest.requiredDone} de ${total} obrigatórios` : 'Nenhum obrigatório';
    }

    public get summarySignature(): string | null {
        if (!this.userData?.selectedService) return null;

        return this.userData.haveSign ? 'Com gov.br' : 'Não precisa';
    }

    public openApproveAndForward(): void {
        this.global.showModalInfo(this.modalName + '-aprovar');
        this.getDepartments();
    }

    public openForwardToSigners(): void {
        this.global.showModalInfo(this.modalName + '-encaminhar');
    }
}
